import notice from "./job-result/notice";
import exclusion from "./job-result/exclusion";
import sendOff from "./job-result/send-off";

const store = {
	namespaced: true,
	modules: {
		notice,
		exclusion,
		sendOff,
	}
};

export default store;
